module.exports = __webpack_public_path__ + "static/washington-65223d2031e4bfdd4653dc4c22d02ece.png";